<template>
	<span
		class="svg-icon"
		v-html="svgContent"
		:style="{
			'--font-size': sizePx,
			fontSize: sizePx,
			color: color
		}"
		v-bind="$attrs"
	></span>
</template>

<script>
export default {
	name: 'SvgIcon',
	props: {
		/** 图标名称（不带 .svg） */
		name: {
			type: String,
			required: true
		},
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: ''
		},
		/** OSS 地址前缀，如：https://your-bucket.oss-cn-xxx.aliyuncs.com/icons */
		prefix: {
			type: String,
			default: 'https://hsylc.oss-cn-hangzhou.aliyuncs.com/svg-icon/'
		}
	},
	data() {
		return {
			svgContent: ''
		};
	},
	computed: {
		sizePx() {
			return this.toUnit(this.size);
		}
	},
	mounted() {
		this.loadSvg();
	},
	watch: {
		name() {
			this.loadSvg();
		},
		color() {
			this.loadSvg();
		}
	},
	methods: {
		toUnit(value) {
			if (value === undefined || value === null) return undefined;
			return `${value}px`;
		},
		async loadSvg() {
			if (!this.name) return;

			const url = `${this.prefix}${this.name}.svg`;

			try {
				const res = await fetch(url);
				if (!res.ok) throw new Error(`加载失败: ${url}`);

				let svgText = await res.text();

				// 强制让根节点宽高跟随容器，避免 SVG 内联固定值
				svgText = svgText.replace(/<svg([^>]*?)>/i, (_, attrs) => {
					let nextAttrs = attrs.replace(/\bwidth\s*=\s*"(.*?)"/i, "");
					nextAttrs = nextAttrs.replace(/\bheight\s*=\s*"(.*?)"/i, "");
					return `<svg${nextAttrs}>`;
				});

				svgText = svgText.replace(/fill=".*?"/g, "fill='currentColor'");

				this.svgContent = svgText;
			} catch (err) {
				console.error("SvgIcon 加载失败：", err);
				this.svgContent = "";
			}
		}
	}
};
</script>

<style scoped lang="less" src="./index.less">
</style>